const FADE_DURATION_MS = 100;
const PULSATION_DURATION_MS = 900;
const buttonCls = "_61b6u7iw7";
const closeIconCls = "_61cjbgplq";
const iconCls = "_61itlsnhj";
const badgeCls = "_61b1wwvytt";
const notebookContainerCls = "_61n1bd4aqi";
const notebookCls = "_61n4y5rgb";

export { FADE_DURATION_MS, PULSATION_DURATION_MS, badgeCls, buttonCls, closeIconCls, iconCls, notebookCls, notebookContainerCls };
import "./notebook-button.style.linaria.module.css";
//# sourceMappingURL=notebook-button.style.js.map
